import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import {React,useState,useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';


export default function ParkingCardsDialog(props) {
    const {open,onClose,idToken,apiDomain,parkingCards=["",""],customerFullname}=props;
    const defaultErrors={"card1No":"","card2No":""};
    const defaultValues={"card1No":parkingCards[0],"card2No":parkingCards[1],customer_name:customerFullname};
    //const defaultValues={"fname":"1Greek","lname":"Tester","email":"alexisod@gmail.com","mobile":"333","lang":"gr"};
    
    const [inputs,setInputs] = useState(defaultValues);
    const [errors,setErrors] = useState(defaultErrors);
    const [isSaving,setIsSaving] = useState(false);
    const [saveError,setSaveError] = useState("");
    useEffect(()=>{
        setInputs(inputs => ({...inputs, 'card1No': parkingCards[0]}));
        setInputs(inputs => ({...inputs, 'card2No': parkingCards[1]}));
        setInputs(inputs => ({...inputs, 'customer_name': customerFullname}));
      },[open]);
    const handleInputChange = (event) => {
      event.persist();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));
      }
    const handleCancel = () => {
        onClose(null);
        resetData();
      };
    const handleClose = () => {
      onClose(null);
      };
    const resetData=()=>{
        setInputs(defaultValues);
        setErrors(defaultErrors);
        setSaveError("");
      }
    const handleSave = async (event) => {
        if(event){
          event.preventDefault();
        }
        const validationErrors = validate(inputs);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors(validationErrors);
        if(noErrors){
          save();
        }
      }

      const save=async ()=>{
        setIsSaving(true);
        //await sleep(1000);
          const params=`/members/gate/registerparkingcards/`;
          fetch(apiDomain+params,{
            "headers":{"id_token":idToken,'Content-Type': 'application/json'},
            method:"post",
            body:JSON.stringify(inputs)
          })
          .then(res => res.text())
          .then(res => JSON.parse(res))
          .then(res => {
            setIsSaving(false);
            resetData();
            onClose({})
            
        } )
        .catch((error)=>{
            console.log(error);
            setSaveError(error.message);
            setIsSaving(false);
        });
      }


    const validate = (inputs) => {
        //Email errors
       const validationErrors = {};
       return validationErrors;
     }
    function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }
    const useStyles = makeStyles((theme) => ({
        root: {
          '& .MuiTextField-root': {
            margin: theme.spacing(1),
          },
          '& .M2uiInput-root': {
            margin: theme.spacing(1),
          }},
          formControl: {
            margin: theme.spacing(1),
          },
          selectEmpty: {
            margin: theme.spacing(1),
          },
        
      }));
    const classes = useStyles();
    return (
        <div>
          <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Manage member's parking cards</DialogTitle>
            <DialogContent>
              <DialogContentText>
                Cards will not activate until membership for the currently running year is settled. If end of season then cards will be active until 31st March of next year provided that member has settled their membership for the current year.
              </DialogContentText>
              <form className={classes.root} noValidate autoComplete="off">
                <TextField name="card1No" onChange={handleInputChange} value={inputs.card1No} error={Boolean(errors.card1No)} helperText={errors.card1No} label="Card 1" variant="standard" required fullWidth/>
                <TextField name="card2No" onChange={handleInputChange} value={inputs.card2No} error={Boolean(errors.card2No)} helperText={errors.card2No} label="Card 2" variant="standard" required fullWidth/>
              </form> 
              {saveError&&<DialogContentText>
                <Typography color="secondary">{saveError}</Typography>
              </DialogContentText>
              }
            </DialogContent>
            <DialogActions style={{minHeight:60}}>
              {isSaving&&<CircularProgress/>}
              <Button style={{position:'absolute',left:20}} onClick={resetData} color="secondary" size="medium" disabled={isSaving}>Reset</Button>
              <Button onClick={handleCancel} color="primary" size="medium" variant="text"disabled={isSaving}>Cancel</Button>
              <Button onClick={handleSave} color="primary" size="medium"  variant="text" disabled={isSaving}>Save</Button>
            </DialogActions>
          </Dialog>
        </div>
      );
}